// removed by extract-text-webpack-plugin
module.exports = {"Spinner":"Spinner--3F8-O","spin":"spin--3LHDz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner/Spinner.local.css
// module id = 969
// module chunks = 3